export default "/images/4ae77c0fd34390adee1d98c1f2458eb7.avif";